import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Time extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                width: 660,
                height: 200,
                marginLeft: 250,
            },
            yAxis: {
                min: -3,
                max: 3,
                tickInterval: 1,
                title: {
                    style: {
                        fontSize: '8pt',
                        color: 'black'
                    }
                },
                labels: {
                    useHTML: true,
                    style: {
                        fontSize: '9pt',
                        color: 'black'
                    },
                },
            },
            xAxis: {
                labels: {
                    useHTML: true,
                    style: {
                        fontSize: '10pt',
                        color: 'black'
                    }
                },
                lineColor: 'black',
                tickWidth: 0
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Time)}